// extracted by mini-css-extract-plugin
export var contentContainer = "TextModule-module--contentContainer--ad6c3";
export var text = "TextModule-module--text--77a9a";
export var title = "TextModule-module--title--245a3";